// @ts-strict-ignore
import {Component, computed, inject, Injector, OnInit, viewChild} from "@angular/core";
import {Translations} from "@translations";
import {SimConfigurationService, SimSessionService} from "@services";
import {zoomInOnEnterAnimation, zoomOutOnLeaveAnimation} from "angular-animations";
import {animate, query, stagger, style, transition, trigger} from "@angular/animations";
import {BasicMaterialDialog} from "../../basic-material-dialog/basic-material-dialog.directive";
import {TeamTrainingSessionStateService} from "./service/team-training-session-state.service";
import {MatStepper} from "@angular/material/stepper";
import {AbstractControl} from "@angular/forms";
import {SessionDialogInput, SessionDialogOutput} from "@common/models/session-dialog";

@Component({
	selector: "sim-team-training-session-dialog",
	templateUrl: "./team-training-session-dialog.component.html",
	styleUrls: ["./team-training-session-dialog.component.scss"],
	providers: [TeamTrainingSessionStateService],
	animations: [
		zoomInOnEnterAnimation({duration: 250, delay: 260}),
		zoomOutOnLeaveAnimation({duration: 250}),
		trigger("listStagger", [
			transition("* <=> *", [
				query(
					":enter",
					[
						style({opacity: 0, transform: "translateY(-15px)"}),
						stagger(
							"50ms",
							animate(
								"550ms ease-out",
								style({
									opacity: 1,
									transform: "translateY(0px)",
								}),
							),
						),
					],
					{optional: true},
				),
				query(
					":leave",
					[
						style({opacity: 1, marginTop: "0"}),
						stagger(
							"50ms",
							animate(
								"550ms ease-out",
								style({
									height: "0",
									overflow: "hidden",
									opacity: 0,
								}),
							),
						),
					],
					{
						optional: true,
					},
				),
			]),
		]),
	],
	standalone: false,
})
export class TeamTrainingSessionDialogComponent
	extends BasicMaterialDialog<TeamTrainingSessionDialogComponent, SessionDialogInput, SessionDialogOutput>
	implements OnInit
{
	readonly T = Translations;
	public settings = SimConfigurationService.settings;
	public startTime: Date | string = "";
	public stateService = inject(TeamTrainingSessionStateService);
	private _sessionService = inject(SimSessionService);

	// Signals
	public stepper = viewChild<MatStepper>("sessionStepper");
	public currentStepForm = computed<AbstractControl>(() => this._computeCurrentStepForm());

	constructor(protected _injector: Injector) {
		super(_injector);
	}

	public ngOnInit(): void {
		this.stateService.initState(this.data.sessionId, this.data.eventId, this.data.eventDay).then();
	}

	private _computeCurrentStepForm() {
		switch (this.stepper().selectedIndex) {
			case 0:
				return this.stateService.step1Form;
			case 1:
				return this.stateService.step2Form;
		}
	}

	public async closeDialog(): Promise<void> {
		if (this.stateService.session.id) {
			const outputSession = await this._sessionService.getSessionById(this.stateService.session.id);
			this.dialogRef.close({action: "ok", outputSession});
		} else {
			this.dialogRef.close({action: "cancel", outputSession: null});
		}
	}
}
